module.exports = __webpack_public_path__ + "img/canopy-single.342a9c4a.svg";